module.exports = __webpack_public_path__ + "img/e6c3189.png";